import { logFeature } from '@office-start/telemetry-service';
import { getRequestIdFromResponse } from '@office-start/xhr-service';
export function logUploadFeature(eventName, sessionId, response, params) {
    var otelParams = params || {};
    if (sessionId) {
        otelParams["UploadSessionId" /* InstrumentationParam.UploadSessionId */] = sessionId;
    }
    if (response) {
        otelParams["RequestId" /* InstrumentationParam.RequestId */] =
            getRequestIdFromResponse(response) || '';
    }
    logFeature({
        featureName: "Upload" /* KnownFeatureNames.Upload */,
        eventName: eventName,
        params: otelParams,
    });
}
//# sourceMappingURL=logUploadFeature.js.map